import React from 'react';

interface ErrorMessageProps {
	children?: React.ReactNode;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = props => {
	if (!props.children) return null;

	return <div className="app-error">{props.children}</div>;
};
